<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <slot name="header">
        <h4 class="modal-title mb-0">{{ _T('Confirmation Modal') }}</h4>
      </slot>
    </template>
    <template v-slot:modal-body>
      <div class="check-email">
        <slot name="body">
          <h6>{{ _T('Are you sure about this action') }}?</h6>
        </slot>
        <div class="btns">
          <button
            type="button"
            class="btn btn-outline"
            @click="$bvModal.hide(modalId)"
          >
            {{ _T('No') }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="confirmationAction"
          >
            {{ _T('Yes') }}
          </button>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'ConfirmationModal',
  props: {
    modalId: {
      type: String,
      default: 'logout',
      required: true,
    },
    confirmationAction: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped></style>
